import React from "react";
import "./Footer.css";


class Footer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }
    render() {
        return (
            <footer>
                <div className="container">
                    <div className="footer_main">
                        <div className="footer_left">
                            <ul>
                                <li>
                                    <a>
                                        Terms and Conditions
                                    </a>
                                </li>
                                <li>
                                    <a>Privacy Policy</a>
                                </li>
                                <li>
                                    <a>Resources</a>
                                </li>
                                <li>
                                    <a>Litepaper</a>
                                </li>
                                <li>
                                    <a>Press</a>
                                </li>
                            </ul>
                        </div>
                        <div className="footer_right">
                            <ul>
                                <li>CONNECT</li>
                                <li>
                                    <a>Twitter</a>
                                </li>
                                <li>
                                    <a>Instgram</a>
                                </li>
                                <li>
                                    <a>Telegram</a>
                                </li>
                            </ul>
                        </div>
                        <div className="footer_bottom">
                            <div className="footer_bottom_left">
                                <img src="img/Rectangle.svg" />
                                <span>Squirrel © All Rights Reserved
                                </span>
                            </div>
                            <div className="footer_bottom_right">
                                <a>
                                    <img src="img/footer_links/1.svg" />
                                </a>
                                <a>
                                    <img src="img/footer_links/2.svg" />
                                </a>
                                <a>
                                    <img src="img/footer_links/3.svg" />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </footer >
        );
    }
}

export default Footer;
